import AuthService from "./AuthService";

// Proveri port - tvoj PatientService koristi 8081, a ranije smo pominjali 8080. 
// Stavi onaj na kojem ti zaista radi Spring Boot.
//const API_URL = "http://localhost:8081/api/shifts";
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8081";
const API_URL = `${API_BASE_URL}/api/shifts`;

class ShiftService {
  
  // Dobavljanje svih smena (za kalendar)
  getAll() {
    return fetch(API_URL, {
      headers: {
        "Content-Type": "application/json",
        ...AuthService.getAuthHeader(),
      },
    }).then(async (res) => {
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Greška pri učitavanju smena: ${res.status} - ${text}`);
      }
      return res.json();
    });
  }

  // Kreiranje nove smene
  create(shift) {
    return fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...AuthService.getAuthHeader(),
      },
      body: JSON.stringify(shift),
    }).then(async (res) => {
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Greška pri čuvanju smene: ${res.status} - ${text}`);
      }
      const contentType = res.headers.get("Content-Type");
      return contentType && contentType.includes("application/json")
        ? res.json()
        : {};
    });
  }

  // Brisanje smene po ID-u
  // Brisanje smene po ID-u
  delete(id) {
    // DODATA KOSA CRTA OVDE: `${API_URL}/${id}`
    return fetch(`${API_URL}/${id}`, {
      method: "DELETE",
      headers: {
        ...AuthService.getAuthHeader(),
      },
    }).then(async (res) => {
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Greška pri brisanju: ${res.status} - ${text}`);
      }
      // Proveri status 204 (No Content)
      if (res.status === 204) return {};
      
      // Ako tvoj kontroler ne vraća ništa, ne pokušavaj res.json()
      const text = await res.text();
      return text ? JSON.parse(text) : {};
    });
  }

  // Opciono: Dobavljanje smena za specifičnog korisnika
  getByUserId(userId) {
    return fetch(`${API_URL}user/${userId}`, {
      headers: {
        "Content-Type": "application/json",
        ...AuthService.getAuthHeader(),
      },
    }).then(async (res) => {
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Greška: ${res.status} - ${text}`);
      }
      return res.json();
    });
  }
}

export default new ShiftService();